import React from 'react';
import { observer } from 'mobx-react';
import { Fade } from '@material-ui/core';
import { isSuccessState } from 'globals/utils';
import reportLocales from 'globals/locales/report';
import { green } from 'globals/colors';
import { useReportContext } from 'contexts/report/ReportContext';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsStatusLabel from 'ui-elements/common-elements/FsStatusLabel';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import {
  Caption,
  DataRow,
  Value,
  ValueBox,
} from './BankAccounts.style-elements';

// Locales
const {
  bankAccounts: { title, captions },
} = reportLocales;

const BankAccounts: React.FC = () => {
  const {
    report: {
      basicInfo: { status },
    },
  } = useReportContext();

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
        withMargin={false}
      />
    );

  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsPaper title={title} data-test="bank-accounts-component">
        <FsMinWidthScrollBox breakpointDown="sm">
          <DataRow>
            <Caption>{captions.accountOpened}</Caption>
            <Value>18.03.1984</Value>
          </DataRow>
          <DataRow isLast>
            <Caption>{captions.hasActiveAccount}</Caption>
            <ValueBox>
              <FsStatusLabel bgColor={green.MAIN} isFullWidth={false}>
                Yes
              </FsStatusLabel>
            </ValueBox>
          </DataRow>
        </FsMinWidthScrollBox>
      </FsPaper>
    </Fade>
  );
};

export default observer(BankAccounts);
